<template>
    <div class="all1">
      <!--    页眉-->
      <div class="all_top">
        <div class="all_top_cen">
          <div class="all_top_cen_left" @click="AddFavorite('http://bgsxqy.com/index/index/index1','加入收藏')">
            <img src="../assets/xingxing.png" alt />
            收藏全友
          </div>
          <div class="all_top_cen_right">
            <div class="all_top_cen_right_text" v-if="$store.state.user.token">
              <span>欢迎来到全友！</span>
              <span>{{zhenshi || '游客'}}</span>
              <span @click="getDel">退出</span>
            </div>
            <div class="all_top_cen_right_text" v-else>
              <span>欢迎来到全友！</span>
              <span @click="$router.push({path:'/login/'})">请登录</span>
              <span @click="$router.push({path:'/register/'})">免费注册</span>
            </div>
            <div class="all_top_cen_right_ding" v-if="$store.state.user.token">
              <span @click="$router.push({path:'/personalCenter',query:{page:1}})">我的订单</span>
            </div>
            <div v-if="$store.state.user.token">
              <div
                class="all_top_cen_right_quan"
                @mouseenter="entersyou(1)"
                @mouseleave="entersyou1(2)"
                v-if="you == 2"
              >
                <span>我的全友</span>
                <img src="../assets/xiajiantou.png" alt />
              </div>
              <div
                class="all_top_cen_right_quan gaibianYou"
                @mouseenter="entersyou(1)"
                @mouseleave="entersyou1(2)"
                v-if="you == 1"
              >
                <div class="all_top_cen_right_quan_cen">
                  <span>我的全友</span>
                  <img src="../assets/shangjiantou.png" alt />
                </div>
                <div class="all_top_cen_right_quan_pos">
                  <div class="all_top_cen_right_quan_pos_top">
                    <img :src="$store.state.Url+$store.state.user.uesr.image" alt />
                    <p v-if="$store.state.user.token">{{zhenshi}}</p>
                    <p v-else>欢迎来到全友！请登录</p>
                    <div class="clear"></div>
                  </div>
                  <div class="all_top_cen_right_quan_pos_cen" @click="$router.push({path:'/personalCenter'})">
                    <p @click="$router.push({path:'/personalCenter',query:{page:1}})">收货地址</p>
                    <!--                  <p>我的留言</p>-->
                    <!--                  <p>缺货登记</p>-->
                    <!--                  <p>我的评论</p>-->
                    <p @click="$router.push({path:'/personalCenter',query:{page:3}})">个人信息</p>
                    <!--                  <p>我的红包</p>-->
                    <p>我的收藏</p>
                    <!--                  <p>资金管理</p>-->
                  </div>
                  <div class="all_top_cen_right_quan_pos_img" style="display: none">
                    <p>最近浏览</p>
                    <div class="all_top_cen_right_quan_pos_img_for">
                      <img src="../assets/guanggaotu2.jpg" alt v-for="item in 7" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="all_top_cen_right_ke" v-if="$store.state.user.token">
<!--               @mouseenter="enters(1)" @mouseleave="leaver(2)" -->
              <div class="all_top_cen_right_ke1">
<!--                <span>客户服务</span>-->
                <span @click="$router.push({path:'/personalCenter'})">个人中心</span>
<!--                <img src="../assets/xiajiantou.png" alt />-->
              </div>
            </div>
            <div
              class="all_top_cen_right_ke_pos"
              v-if="NameType == 1"
              @mouseenter="enters(1)"
              @mouseleave="leaver(2)"
            >
              <div class="all_top_cen_right_ke_pos_for">
                <span>客户服务</span>
                <img src="../assets/shangjiantou.png" alt />
              </div>
              <div class="all_top_cen_right_ke_pos_for">
                <span>帮助中心</span>
              </div>
              <div class="all_top_cen_right_ke_pos_for">
                <span>售后服务</span>
              </div>
              <div class="all_top_cen_right_ke_pos_for">
                <span>在线客服</span>
              </div>
              <div class="all_top_cen_right_ke_pos_for">
                <span>投诉中心</span>
              </div>
              <div class="all_top_cen_right_ke_pos_for">
                <span>客服邮箱</span>
              </div>
            </div>
          </div>
          <div class="clear"></div>
        </div>
      </div>
      <!--    login 电话 搜索-->
      <div class="all_search">
        <div class="all_search_login" @click="$router.push({path:'/'})">
          <img src="../assets/logo.jpg" alt />
        </div>
        <div class="all_search_search">
          <input type="text" v-model="shopName" @keyup.enter="getSearch"/>
          <p @click="getSearch">搜 索</p>
          <div class="clear"></div>
          <div class="all_search_search_pos" style="font-size: 12px">
            <a>热点关键字：</a>
            <span v-for="(item,index) in hot" @click="getHotName(item.name)" :key="index">{{item.name}}</span>
          </div>
        </div>
        <div class="all_search_phone">
          <img src="../assets/fon.jpg" alt />
        </div>
        <div class="clear"></div>
      </div>
      <!--    导航-->
      <div class="all_Navigation">
        <div class="all_Navigation_cen">
          <div class="all_Navigation_cen_left">
            <ul class="all_Navigation_cen_left_ul">
              <li class="all_jingguo abvc">全部商品分类
                <div class="all_chart_chart_pos_nav">
                  <ul>
                    <li v-for="(item,key) in all.class" :key="key">
<!--                       @click="getList(item.id,item.id,item.name)"-->
                      <p>{{ item.name }}</p>
                      <div class="all_chart_chart_pos_nav_li_X" @mouseout="all_jingguo1(2)">
                        <div
                          class="all_chart_chart_pos_nav_li_X_for"
                          v-for="(cla,index) in item.class_cation"
                          :key="index"
                        >
                          <div class="all_chart_chart_pos_nav_li_X_for_left" @click="getList(item.id,cla.id,cla.name)">{{ cla.name }}</div>
                          <div class="all_chart_chart_pos_nav_li_X_for_right">
                            <span v-for="(val,index) in cla.class_three" :key="index" @click="getList1(item.id,val.id,val.name)">{{ val.name }}</span>
                            <!--        热门品牌哦-->
                            <div class="all_chart_chart_pos1">
                              <div class="all_chart_chart_pos1_top">
                                <div>
                                  <img :src="$store.state.Url+good.logo" alt v-for="(good,key) in item.brand_logo" @click="getPinpai(good.url)"/>
                                </div>
                                <div class="clear"></div>
                              </div>
                              <div class="all_chart_chart_pos1_cen">
                                <img :src="$store.state.Url+good.goods_img" alt v-for="(good,key) in item.goods_logo" @click="getxiangqing(good.id)"/>
                              </div>
                            </div>
                          </div>
                          <div class="clear"></div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </li>
<!--               @click="$router.push({path:'/ListOfCommodities'})"-->
              <li class="abvc" @click="$router.push({path:'/'})">首页</li>
<!--              <li>电脑数码用品</li>-->
              <li class="abvc" @click="$router.push({path:'/jiejue'})">解决方案</li>
              <li class="abvc" @click="$router.push({path:'/dingzhi'})">企业定制</li>
              <li class="abvc" @click="getPerson">申请月结</li>
              <li class="abvc" @click="getPerson1">积分商城</li>
            </ul>
          </div>

          <div class="all_Navigation_cen_right" @click="$router.push({path:'/ShoppingCart'})">
            <div
              class="all_Navigation_cen_right_shop"
              @mouseenter="shop1(1)"
              @mouseleave="shop2(2)"
              v-if="ShopType == 2"
            >
              <img src="../assets/gouwuche.png" alt />
              我的购物车
              <img src="../assets/youjiantou.png" alt />
            </div>
            <div
              class="all_Navigation_cen_right_shop none_shop"
              v-if="ShopType == 1"
              @mouseenter="shop1(1)"
              @mouseleave="shop2(2)"
            >
              <img src="../assets/gouwuche.png" alt />
              我的购物车
              <img src="../assets/youjiantou.png" alt />
          <!--    <div class="all_Navigation_cen_right_shopxiala">
                <div class="all_Navigation_cen_right_shopxiala_shop">
                  <div class="all_Navigation_cen_right_shopxiala_shop_none">
                    <img src="../assets/gouwuchenone.png" alt />
                    <span>购物车中还没有商品，赶紧选购吧！</span>
                  </div>
                </div>
              </div>-->
            </div>
          </div>
          <div class="clear"></div>
        </div>
      </div>
    </div>
</template>

<script>
  import {getHot, getinit} from '../api/index'
    export default {
        name: "Head",
        data(){
            return{
              NameType: 2,
              ShopType: 2,
              you: 2,
              hot:[],
              shopName:this.goodsname,
              // StatusType:true,
              zhenshi:'',
              all:{
                top_img:'',
                left_img:'',
                right_img:'',
                photo:'',
                video:'',
                class_cation:[],
                class:[],
              },
              alljingguo:0,
            }
        },
        props:{
          StatusType:{
            type:Boolean,
            StatusType:true
          },
          goodsname:{
            type:String,
          },
        },
        mounted() {
          this.init()
          this.getinit()
          // console.log(this.$store.state.user)
          // this.zhenshi = this.$store.state.user.uesr.real_name
        },
        methods:{
          all_jingguo(e){
            this.alljingguo = e
          },
          all_jingguo1(e){
            this.alljingguo = e
          },
          getxiangqing(id){
            this.$router.push({path:'/details',query:{id:id,status:2}})
          },
          getCliak(url){
            // console.log(url)
            window.open(url)
          },
          getPinpai(url){
            window.location.href = url
          },
          getList(id,e,name){
            console.log('jsahdj')
            this.$router.push({path:'/ListOfCommodities',query:{Yiji:id,id:e,shop:name}})
          },
          getList1(id,e,name){
            this.$router.push({path:`/ListOfCommodities`,query:{Yiji:id,cat:e,shop:name,time:new Date().valueOf()}})
          },
          getPerson(){
            if (this.$store.state.user.token){
              this.$router.push({path:'/personalCenter',query:{page:8}})
            }else {
              this.$router.push({path:'/login'})
            }
          },
          getPerson1(){
            this.$router.push({path:'/jifen'})
          /*  if (this.$store.state.user.token){
              this.$router.push({path:'/personalCenter',query:{page:5}})
            }else {
              this.$router.push({path:'/login'})
            }*/
          },
          AddFavorite(url,title){
            if(document.all){
              window.external.addFavorite(url,title);
            } else{
              alert("加入收藏失败，请使用Ctrl+D进行添加！");
            }
          },
          getDel(){
            this.$store.dispatch('LogOut').then(res=>{
              window.location.reload()
            })
          },
          initName(){
            this.shopName=this.goodsname
          },
          getHotName(e){
            this.shopName = e
            this.getSearch()
          },
          getSearch(){
            if (this.StatusType){
              console.log('跳也')
              if (this.shopName){
                this.$router.push({path:'/ListOfCommodities',query:{name:this.shopName}})
              }else {

              }
            }else {
              console.log('给父组件传参')
              this.$emit('getEmit',this.shopName)
              if (this.shopName){
                this.$router.push({path:'/ListOfCommodities',query:{name:this.shopName}})
              }else {

              }
            }
          },
          shop1(type) {
            this.ShopType = type;
            // console.log(this.NameType)
          },
          shop2(type) {
            this.ShopType = type;
            // console.log(this.NameType)
          },
          entersyou(type) {
            this.you = type;
            // console.log(this.NameType)
          },
          entersyou1(type) {
            this.you = type;
            // console.log(this.NameType)
          },
          enters(type) {
            this.NameType = type;
            // console.log(this.NameType)
          },
          leaver(type) {
            this.NameType = type;
            // console.log(this.NameType)
          },
          truncate(arr) {
            var m = [];
            for(var i = 0; i < arr.length - 1; i++){
              if (i.id!=4){
                m.push(arr[i]);
              }
            }
            return m;
          },
          init(){
            getHot().then(res=>{
              this.hot = res.result
            })
            getinit().then(res => {
              this.all = res;
              this.all.one_class = this.truncate(this.all.one_class).map((v, i) => {
                //插入参数
                v.two_class.unshift({
                  goods: v.goods,
                  name: ""
                });
                return { ...v, two_class_index: 0, two_class_index1: 0 };
              });
            });
          },
          getinit(){
            if (localStorage.getItem('tokenWeb')){
              this.$store.commit('SET_User',JSON.parse(localStorage.getItem('user')))
              this.$store.dispatch('GetInfo').then(res=>{
                this.zhenshi = this.$store.state.user.uesr.real_name
              })
            }
          },
          ClassInit(id){
            getHot({class_id:id}).then(res=>{
              this.hot = res.result
            })
          }
        },
    }
</script>

<style scoped lang="less">
  @import "css/Head";
</style>



// WEBPACK FOOTER //
// src/assembly/Head.vue